import { useModel as _useModel, mergeDefaults as _mergeDefaults, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, setBlockTracking as _setBlockTracking, createVNode as _createVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex justify-between items-baseline w-full -my-1" };
const _hoisted_2 = { class: "flex justify-between items-baseline" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["aria-label", "title"];
const _hoisted_5 = { class: "py-1" };
const _hoisted_6 = ["disabled", "step", "min", "max"];
const _hoisted_7 = {
    key: 1,
    class: "flex justify-between mt-1 text-sm"
};
import { useId, computed, ref, watch } from 'vue';
import { ___, toNumberStr } from '@ts/common/language';
import { DefaultPropValues } from '@ts/components/form/types';
import { setError, removeError, removeAllErrors, mergeErrors } from '@ts/components/form/utils';
import { secToHhmm, secToHhmmss } from '@ts/common/time';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import ErrorMessage from '@ts/components/form/helpers/ErrorMessage.vue';
import PureNumber from '@ts/components/form/inputs/PureNumber.vue';
import PureTime from '@ts/components/form/inputs/PureTime.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LabeledSlider',
    props: /*@__PURE__*/ _mergeModels(/*@__PURE__*/ _mergeDefaults({
        unit: {},
        min: {},
        max: {},
        step: {},
        type: {},
        displayLimits: { type: Boolean },
        small: { type: Boolean },
        title: {},
        help: {},
        disabled: { type: Boolean },
        allErrors: { type: Boolean },
        errorId: {}
    }, {
        ...DefaultPropValues,
        errorId: () => useId(),
        unit: '',
        min: 0,
        max: 100,
        step: 1,
        type: 'number',
        displayLimits: true,
        small: false,
    }), {
        "value": { required: true },
        "valueModifiers": {},
        "errors": { required: false, default: () => ({}) },
        "errorsModifiers": {},
    }),
    emits: ["update:value", "update:errors"],
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        const value = _useModel(__props, 'value');
        const errors = _useModel(__props, 'errors');
        const typedInput = ref(value.value);
        watch(() => value.value, (newVal) => {
            validate(newVal);
            if (newVal !== typedInput.value) {
                typedInput.value = isNaN(newVal) ? null : newVal;
            }
        }, { immediate: true });
        watch(() => typedInput.value, (newVal) => {
            if (newVal !== null) {
                validate(newVal);
                if (newVal !== value.value) {
                    value.value = newVal;
                }
            }
        });
        function validate(num) {
            removeError(errors, props.errorId, 'nan');
            removeError(errors, props.errorId, 'min');
            removeError(errors, props.errorId, 'max');
            if (isNaN(num)) {
                setError(errors, props.errorId, 'nan', ___({ en: 'Value is not a number.', de: 'Der Wert ist keine Zahl.' }));
            }
            else if (num > props.max) {
                setError(errors, props.errorId, 'max', ___({ en: `Value must be less than or equal to ${toNumberStr(props.max)}.`, de: `Der Wert muss kleiner oder gleich ${toNumberStr(props.max)} sein.` }));
            }
            else if (num < props.min) {
                setError(errors, props.errorId, 'min', ___({ en: `Value must be greater than or equal to ${toNumberStr(props.min)}.`, de: `Der Wert muss größer oder gleich ${toNumberStr(props.min)} sein.` }));
            }
        }
        const numChars = computed(() => {
            if (props.type == 'hh:mm')
                return 5;
            else if (props.type == 'hh:mm:ss')
                return 8;
            else {
                return Math.max(props.min.toString().length, (props.min + props.step).toString().length, (props.max - props.step).toString().length, props.max.toString().length);
            }
        });
        const minText = computed(() => {
            return props.type == 'hh:mm' ? secToHhmm(props.min) : props.type == 'hh:mm:ss' ? secToHhmmss(props.min) : toNumberStr(props.min);
        });
        const maxText = computed(() => {
            return props.type == 'hh:mm' ? secToHhmm(props.max) : props.type == 'hh:mm:ss' ? secToHhmmss(props.max) : toNumberStr(props.max);
        });
        const computedErrors = computed(() => {
            if (props.allErrors) {
                return mergeErrors(errors.value);
            }
            else {
                return props.errorId ? errors.value[props.errorId] || {} : {};
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", {
                            class: _normalizeClass(["label mb-0 me-2", { 'invalid': Object.keys(computedErrors.value).length > 0, 'text-sm': props.small === true }]),
                            innerHTML: __props.title
                        }, null, 10 /* CLASS, PROPS */, _hoisted_3),
                        (props.type === 'hh:mm' || props.type === 'hh:mm:ss')
                            ? (_openBlock(), _createBlock(PureTime, {
                                key: 0,
                                value: typedInput.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((typedInput).value = $event)),
                                errors: errors.value,
                                "onUpdate:errors": _cache[1] || (_cache[1] = ($event) => ((errors).value = $event)),
                                type: "text",
                                class: _normalizeClass(["input-default not-active:bg-transparent not-active:border-transparent py-1 px-1 text-end", { invalid: Object.keys(computedErrors.value).length > 0, 'px-2 py-1.5 text-sm': props.small === true }]),
                                disabled: __props.disabled,
                                maxlength: numChars.value,
                                size: numChars.value,
                                "has-seconds": props.type === 'hh:mm:ss',
                                "error-id": props.errorId,
                                "not-null": true,
                                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
                            }, null, 8 /* PROPS */, ["value", "errors", "class", "disabled", "maxlength", "size", "has-seconds", "error-id"]))
                            : (_openBlock(), _createBlock(PureNumber, {
                                key: 1,
                                value: typedInput.value,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((typedInput).value = $event)),
                                errors: errors.value,
                                "onUpdate:errors": _cache[4] || (_cache[4] = ($event) => ((errors).value = $event)),
                                type: "text",
                                class: _normalizeClass(["input-default not-active:bg-transparent not-active:border-transparent py-1 px-1 text-end", { invalid: Object.keys(computedErrors.value).length > 0, 'px-2 py-1.5 text-sm': props.small === true }]),
                                disabled: __props.disabled,
                                size: numChars.value,
                                separator: _unref(___)({ en: '.', de: ',' }),
                                "error-id": props.errorId,
                                "not-null": true,
                                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
                            }, null, 8 /* PROPS */, ["value", "errors", "class", "disabled", "size", "separator", "error-id"])),
                        _createElementVNode("div", {
                            class: _normalizeClass(["label ms-0.5 whitespace-nowrap", { 'text-muted': __props.disabled, 'text-sm': props.small === true }])
                        }, _toDisplayString(__props.unit), 3 /* TEXT, CLASS */)
                    ]),
                    (__props.help.trim() !== '')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[7] || (_cache[7] = ($event) => (showHelp.value = !showHelp.value)),
                            type: "button",
                            class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500 ml-2",
                            "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                            title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                        }, [
                            _cache[6] || (_setBlockTracking(-1, true),
                                (_cache[6] = _createVNode(SvgVue, {
                                    class: "w-4 h-4",
                                    icon: "lucide/circle-question-mark"
                                })).cacheIndex = 6,
                                _setBlockTracking(1),
                                _cache[6])
                        ], 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                ]),
                (__props.help.trim() !== '')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["collapsible", showHelp.value ? 'expanded' : ''])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["text-muted collapsible-content", { 'text-sm': props.small === true }])
                        }, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.help), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                _withDirectives(_createElementVNode("input", {
                    type: "range",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((value).value = $event)),
                    class: _normalizeClass(["input-default w-full mt-2", { invalid: Object.keys(computedErrors.value).length > 0 }]),
                    disabled: __props.disabled,
                    step: __props.step,
                    min: __props.min,
                    max: __props.max
                }, null, 10 /* CLASS, PROPS */, _hoisted_6), [
                    [
                        _vModelText,
                        value.value,
                        void 0,
                        { number: true }
                    ]
                ]),
                (__props.displayLimits)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", {
                            class: _normalizeClass(["", { 'text-muted': __props.disabled, 'text-xs': props.small === true }])
                        }, _toDisplayString(minText.value) + " " + _toDisplayString(__props.unit), 3 /* TEXT, CLASS */),
                        _createElementVNode("span", {
                            class: _normalizeClass(["", { 'text-muted': __props.disabled, 'text-xs': props.small === true }])
                        }, _toDisplayString(maxText.value) + " " + _toDisplayString(__props.unit), 3 /* TEXT, CLASS */)
                    ]))
                    : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedErrors.value, (item, key) => {
                    return (_openBlock(), _createBlock(ErrorMessage, {
                        error: item,
                        key: key,
                        small: props.small
                    }, null, 8 /* PROPS */, ["error", "small"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
